/* 1801 Page — GSAP scroll animations + interactive SVG details */

(function() {
  /* Wait for GSAP + ScrollTrigger to load */
  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      return setTimeout(init, 100);
    }
    gsap.registerPlugin(ScrollTrigger);

    /* ── "What Is 1801?" scroll animation ── */
    var startPosition = window.matchMedia('(max-width: 768px)').matches
      ? 'top 80%'
      : 'top top+=450';

    gsap.timeline({
      ease: 'power2.out',
      scrollTrigger: {
        trigger: '.intro_txt-timeline',
        start: startPosition,
        end: '+=350',
        pin: false,
        scrub: 1,
        markers: false
      },
      defaults: { duration: 300 }
    })
    .to('.txt-box-01', { opacity: 1, scale: 1, y: '50%' })
    .to('.box01', { color: '#2d3238' }, 0)
    .to('.txt-box-02', { opacity: 1, scale: 1, y: '50%' }, 2000)
    .to('.box02', { color: '#2d3238' }, 2000)
    .to('.txt-box-03', { opacity: 1, scale: 1, y: '50%' }, 3000)
    .to('.box03', { color: '#2d3238' }, 3000)
    .to({}, {});

    /* ── Interactive SVG Details ── */
    var tl = gsap.timeline();
    var TIMESTEP_IN = 0.6;
    var TIMESTEP_OUT = 0.8;
    var SCALE_OUT = 1;

    var positions = {
      '.node-0': { x: '0%', y: '65%' },
      '.node-1': { x: '0%', y: '0%' },
      '.node-2': { x: '50%', y: '10%' },
      '.node-3': { x: '0%', y: '20%' },
      '.node-4': { x: '0%', y: '20%' }
    };

    function bindNode(sel, handler) {
      var el = document.querySelector(sel);
      if (el) el.addEventListener('click', handler);
    }

    /* Node 0 — Collar zoom */
    bindNode('.node-0', function() {
      tl.to('#SVG_Tree', { duration: TIMESTEP_IN, scale: 2.3, x: positions['.node-0'].x, y: positions['.node-0'].y });
      tl.to('.story-01, .story-02, .story-03, .story-10', { duration: TIMESTEP_IN, opacity: 1, zIndex: 1, scale: 1 })
        .to('.line', { duration: TIMESTEP_IN, opacity: 1 }, '<');
      tl.to('.btn-pulse', { duration: TIMESTEP_IN, opacity: 0 }, '<');
      tl.to('.zoom_out', { duration: TIMESTEP_IN, zIndex: 3, opacity: 1 });
    });

    /* Node 1 — Wider fit */
    bindNode('.node-1', function() {
      tl.to('#SVG_Tree', { duration: TIMESTEP_IN, scale: 1.05, x: positions['.node-1'].x, y: positions['.node-1'].y });
      tl.to('.story-04', { duration: TIMESTEP_IN, opacity: 1, zIndex: 1, scale: 1 });
      tl.to('.btn-pulse', { duration: TIMESTEP_IN, opacity: 0 }, '<');
      tl.to('.line-1', { duration: TIMESTEP_IN, opacity: 1 })
        .to('.zoom_out', { duration: TIMESTEP_IN, zIndex: 3, opacity: 1 }, '<');
    });

    /* Node 2 — Longer sleeves */
    bindNode('.node-2', function() {
      tl.to('#SVG_Tree', { duration: TIMESTEP_IN, scale: 1.55, x: positions['.node-2'].x, y: positions['.node-2'].y });
      tl.to('.story-05', { duration: TIMESTEP_IN, opacity: 1, zIndex: 1, scale: 1 });
      tl.to('.btn-pulse', { duration: TIMESTEP_IN, opacity: 0 }, '<');
      tl.to('.line-2', { duration: TIMESTEP_IN, opacity: 1 })
        .to('.zoom_out', { duration: TIMESTEP_IN, zIndex: 3, opacity: 1 }, '<');
    });

    /* Node 3 — Fabric detail 1 */
    bindNode('.node-3', function() {
      tl.to('#SVG_Tree', { duration: TIMESTEP_IN, scale: 3, x: positions['.node-3'].x, y: positions['.node-3'].y });
      tl.to('.story-06', { duration: TIMESTEP_IN, opacity: 1, zIndex: 1, scale: 1, x: '0%', y: '0%' }, '-=0.3')
        .to('.zoom_out', { duration: TIMESTEP_IN, zIndex: 3, opacity: 1 })
        .to('.story-07', { duration: TIMESTEP_IN, opacity: 1, zIndex: 1, scale: 1 }, '-=0.5');
      tl.to('.btn-pulse', { duration: TIMESTEP_IN, opacity: 0 }, '-=1');
    });

    /* Node 4 — Fabric detail 2 */
    bindNode('.node-4', function() {
      tl.to('#SVG_Tree', { duration: TIMESTEP_IN, scale: 3, x: positions['.node-4'].x, y: positions['.node-4'].y });
      tl.to('.story-08', { duration: TIMESTEP_IN, opacity: 1, zIndex: 1, scale: 1, x: '0%', y: '0%' }, '-=0.3')
        .to('.zoom_out', { duration: TIMESTEP_IN, zIndex: 3, opacity: 1 })
        .to('.story-09', { duration: TIMESTEP_IN, opacity: 1, zIndex: 1, scale: 1 }, '-=0.5');
      tl.to('.btn-pulse', { duration: TIMESTEP_IN, opacity: 0 }, '-=1');
    });

    /* Zoom out / reset */
    var zoomBtn = document.querySelector('button.zoom_out');
    if (zoomBtn) {
      zoomBtn.addEventListener('click', function() {
        if (!tl.isActive()) {
          gsap.to('#SVG_Tree', { duration: TIMESTEP_OUT, scale: SCALE_OUT, x: '0%', y: '0%' });
          gsap.to('.story-txt', { duration: TIMESTEP_IN, opacity: 0, zIndex: -1, scale: 0, x: '0%', y: '0%' });
          gsap.to('.line, .line-1, .line-2', { duration: TIMESTEP_OUT, opacity: 0 });
          gsap.to('.btn-pulse', { duration: TIMESTEP_OUT, opacity: 1 });
          gsap.to('.zoom_out', { duration: TIMESTEP_OUT, opacity: 0, zIndex: -1 });
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
